import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-04/lesson-12/task-02";

const task: Slide = {
  titleHtml: `The impedance of a shaker is shown below. It has a moving mass an electrical</br>resistance R<sub>e</sub> of 2 Ω and a Bℓ factor of 7.9 T.m. From the impedance curve,</br>calculate the value of the mechanical resistance R<sub>t</sub>.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/12/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
